module.exports = __webpack_public_path__ + "4830528421e44656b87de8ce20f0dde5.svg";